<template>
    <swiper :autoplay="true" :loop="false" :slidesPerView="isMobile() ? 'auto' : 4.5" :spaceBetween="isMobile() ? 12 : 15">
        <swiper-slide v-for="item in dataslide" :key="item.event_id">
            <Card :value="item"/>
        </swiper-slide>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import swiper from '../mixins/swiper.js'
import Card from './cardPotrait.vue'
import device from '../mixins/isMobile'
export default {
  props: {
    dataslide: {
      required: false,
      defautl: [],
      type: Array
    }
  },
  mixins: [swiper, device],
  data () {
    return {}
  },
  components: {
    Card,
    Swiper,
    SwiperSlide
  }
}
</script>

<style lang="scss" scoped>
  .cardsMobile{
    display: flex;
    height: 100%;
  }
</style>
